/**
 * ADGMQ
 * imedia
 *
 * Accordion component
 */

(function($) {
  $(document).ready(function() {
    $('.accordion .card').on('show.bs.collapse	', function() {
      var button = $(this).find('button');
      button.text($(this).attr('data-close')).addClass('btn--arrow--close');
    });

    $('.accordion .card').on('hide.bs.collapse', function() {
      var button = $(this).find('button');
      button.text($(this).attr('data-open')).removeClass('btn--arrow--close');
    });

    $('.collapse').on('show.bs.collapse', function(e) {
      var $card = $(this).closest('.card');
      var $open = $($(this).data('parent')).find('.collapse.show');

      var additionalOffset = 0;
      if ($card.prevAll().filter($open.closest('.card')).length !== 0) {
        additionalOffset = $open.height();
      }
      $('html,body').animate(
        {
          scrollTop: $card.offset().top - additionalOffset,
        },
        500,
      );
    });
  });
})(jQuery);
